function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 11L8 13L12 11V6L8 4L4 6V11Z",
  stroke: "#ffffff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8 18L12 20L16 18V13L12 11L8 13V18Z",
  stroke: "#ffffff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12 11L16 13L20 11V6L16 4L12 6V11Z",
  stroke: "#ffffff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8 8L7.77639 8.44721C7.91716 8.5176 8.08284 8.5176 8.22361 8.44721L8 8ZM3.77639 6.44721L7.77639 8.44721L8.22361 7.55279L4.22361 5.55279L3.77639 6.44721ZM8.22361 8.44721L12.2236 6.44721L11.7764 5.55279L7.77639 7.55279L8.22361 8.44721Z",
  fill: "#ffffff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12 15L11.7764 15.4472C11.9172 15.5176 12.0828 15.5176 12.2236 15.4472L12 15ZM7.77639 13.4472L11.7764 15.4472L12.2236 14.5528L8.22361 12.5528L7.77639 13.4472ZM12.2236 15.4472L16.2236 13.4472L15.7764 12.5528L11.7764 14.5528L12.2236 15.4472Z",
  fill: "#ffffff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M16 8L15.7764 8.44721C15.9172 8.5176 16.0828 8.5176 16.2236 8.44721L16 8ZM11.7764 6.44721L15.7764 8.44721L16.2236 7.55279L12.2236 5.55279L11.7764 6.44721ZM16.2236 8.44721L20.2236 6.44721L19.7764 5.55279L15.7764 7.55279L16.2236 8.44721Z",
  fill: "#ffffff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M16 9.5L16 8",
  stroke: "#ffffff",
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  fill: "#ffffff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M8 9.5L8 8",
  stroke: "#ffffff",
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  fill: "#ffffff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12 16.5L12 15",
  stroke: "#ffffff",
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  fill: "#ffffff"
});

var SvgHive = function SvgHive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hive.ccc27677.svg";
export { ForwardRef as ReactComponent };